<template>
    <section>
        <div class="grid-container">
            <div class="profile-label grid-item" data-qa="creditcard-heading">
                Credit cards
            </div>
        </div>

        <template lang="html">
            <div class="display-credit-cards">
                <ds-table-grid
                    :data="creditCards"
                    align="center"
                    :click-row="openCreditCard"
                >
                    <ds-table-grid-column
                        label="Type"
                        width="100"
                    >
                        <template slot-scope="creditCard">
                            <span>
                                {{ creditCard.cardType }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Name on card"
                        width="120"
                    >
                        <template slot-scope="creditCard">
                            <span :title="creditCard.nameOnCard">
                                {{ modifyValidationMessage(creditCard.nameOnCard) }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Number"
                        width="110"
                    >
                        <template slot-scope="creditCard">
                            <span>
                                {{ splitForFourDigit(creditCard.scrubbedCardNumber) }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Exp"
                        width="60"
                    >
                        <template slot-scope="creditCard">
                            <span>
                                {{ creditCard.expiration || 'XX / XX' }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Validation status"
                        width="100"
                    >
                        <template slot-scope="creditCard">
                            <div v-if="creditCardValidationCheck(creditCard)">
                                <span :class="checkValidationStatusKeys(creditCard)" :title="checkValidationStatusValues(creditCard)">
                                    {{ modifyValidationMessage(checkValidationStatusValues(creditCard)) }}
                                </span>
                            </div>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Validation message"
                        width="120"
                    >
                        <template slot-scope="creditCard">
                            <span :title="creditCard.statusMsg">
                                {{ modifyValidationMessage(creditCard.statusMsg) || 'No Message' }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column label="Charges Run">
                        <template slot-scope="creditCard">
                            <span>
                                {{ creditCard.chargesRun }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column label="Charges failed">
                        <template slot-scope="creditCard">
                            <span>
                                {{ creditCard.chargesFailed }}
                            </span>
                        </template>
                    </ds-table-grid-column>
                </ds-table-grid>
            </div>
            <credit-card-form ref="creditCardModal" :contact="contact" />
        </template>
    </section>
</template>

<script>
import CreditCardForm from '@/components/contact/CreditCardForm';

export default {
    components: {
        CreditCardForm,
    },
    props: {
        creditCards: Array,
        contact: Object,
    },

    methods: {
        modifyValidationMessage(message) {
            if (message !== undefined && message.length > 20) {
                return `${message.slice(0, 20)}...`;
            }

            return message;
        },

        creditCardValidationCheck(creditCardData) {
            return creditCardData !== null
                    && Object.keys(creditCardData).length !== 0;
        },

        splitForFourDigit(scrubbedCardNumber) {
            if (scrubbedCardNumber) {
                let val = scrubbedCardNumber;
                let newVal = '';

                val = val.toString().replace(/\s/g, '');

                for (let i = 0; i < val.length; i++) {
                    if (i % 4 === 0 && i > 0) newVal = newVal.concat(' ');
                    newVal = newVal.concat(val[i]);
                }

                return newVal;
            }

            return null;
        },

        checkValidationStatusKeys(creditCardDataSample) {
            return Object.keys(creditCardDataSample.creditCardValidationStatus)[0];
        },

        checkValidationStatusValues(creditCardDataSample) {
            return Object.values(creditCardDataSample.creditCardValidationStatus)[0];
        },

        openCreditCard(creditCard) {
            this.$refs.creditCardModal.showModal(creditCard.id);
        },
    },
};
</script>

<style lang="scss" scoped>

.grid-container {
    display: flex;
    margin: $spacing-250 0;
}

.grid-item {
    margin: auto;
}

.profile-label {
    margin-left: 0;
    font-size: 1.75rem;
    color: $color-text;
}

.display-credit-cards {
    white-space: nowrap;
    overflow-x: hidden !important;
    cursor: pointer;
}

.Good {
    color: $color-blue;
}

.Bad {
    color: $color-red;
}

.Deleted {
    color: $color-red;
}

.Inactive {
    color: $color-red;
}

.Unknown {
    color: $color-orange;
}

@media only screen and ($medium) {
    .grid-container {
        margin-top: 1.875rem;
        display: block;
    }
}
</style>
